var _path, _path2, _path3, _path4, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkups({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138 503.5C138 503.5 42.0538 398.635 26.7858 375.502C11.5178 352.369 26.7858 103.856 26.7858 97.2469C26.7858 90.6377 36.0793 60.8952 45.3729 51.642C54.6665 42.3889 71.9261 31.6116 84.5387 31.153C97.1514 30.6945 360.691 15.2905 376.623 31.153C392.554 47.0156 591.039 236.705 591.039 236.705",
    stroke: "black",
    strokeWidth: 38
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190 559C190 559 405.831 754.881 418.444 762.151C431.056 769.422 442.341 772.726 460.929 774.709C479.516 776.692 499.431 768.1 514.699 762.151C529.967 756.203 767.617 514.96 769.608 511.655C771.6 508.351 778.238 497.115 778.902 476.626C779.565 456.136 776.91 442.918 769.608 429.038C762.306 415.158 632.196 276.361 632.196 276.361",
    stroke: "black",
    strokeWidth: 40
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M303.533 222.164C303.533 266.191 267.668 302 223.279 302C178.889 302 143.024 266.191 143.024 222.164C143.024 178.137 178.889 142.328 223.279 142.328C267.668 142.328 303.533 178.137 303.533 222.164Z",
    stroke: "black",
    strokeWidth: 35
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 613C10.5 613 205.157 427 208.5 427C211.843 427 257.157 474.5 260.5 474.5C263.843 474.5 484.172 245.521 488.351 244.583C492.53 243.645 525.961 289.594 529.304 290.532C532.647 291.469 696.457 114.239 694.785 109.55C693.114 104.861 667.205 87.0448 668.041 82.3561C668.876 77.6674 774.183 60.7884 778.362 64.5393C782.541 68.2902 764.989 178.004 760.811 178.004C756.632 178.004 747.438 160.188 744.095 161.125C740.752 162.063 534.318 411.498 529.304 409.623C524.289 407.747 491.694 361 488.351 361C485.008 361 272.007 587.875 269.5 586C266.993 584.125 211.007 529.375 208.5 527.5C205.993 525.625 51 696.5 51 696.5",
    stroke: "black",
    strokeWidth: 40
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -12.5,
    x2: 198.715,
    y2: -12.5,
    transform: "matrix(0.708647 -0.705564 0.708647 0.705564 453.626 606.257)",
    stroke: "black",
    strokeWidth: 28
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -12.5,
    x2: 292.291,
    y2: -12.5,
    transform: "matrix(0.708647 -0.705564 0.708647 0.705564 453.618 672.272)",
    stroke: "black",
    strokeWidth: 28
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkups);
export default __webpack_public_path__ + "static/media/markups.9edc32f93f30e0a41ea302abdfed411a.svg";
export { ForwardRef as ReactComponent };